export default __webpack_public_path__ + "static/media/applications-image-17.d7cb3fca.jpg";